export default "__VITE_ASSET__CX0Zv4l$__"